import { render, staticRenderFns } from "./UserProfileUpdate.vue?vue&type=template&id=1d864ab4&scoped=true"
import script from "./UserProfileUpdate.vue?vue&type=script&lang=js"
export * from "./UserProfileUpdate.vue?vue&type=script&lang=js"
import style0 from "./UserProfileUpdate.vue?vue&type=style&index=0&id=1d864ab4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d864ab4",
  null
  
)

export default component.exports